import React, { useEffect, useState } from "react";
import { PlusIcon } from "@heroicons/react/solid";
import {
  Card,
  Modal,
  Form,
  Button,
  InputGroup,
  OverlayTrigger,
  Tooltip,
  ToastContainer,
} from "react-bootstrap";
import Select from "react-select";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { TbEdit, TbTrash } from "react-icons/tb";
import { IoPauseCircleOutline, IoPlay } from "react-icons/io5";
import { IoLogoWhatsapp } from "react-icons/io";
import { AiFillMessage } from "react-icons/ai";
import { BiSolidMessageSquareDetail } from "react-icons/bi";
import { Routes } from "routes";
import { useHistory } from "react-router-dom";
import {
  useChangeFlowStatusMutation,
  useGetFlowsMutation,
} from "Services/services";
import { Toast } from "react-bootstrap";
import hasPermission from "pages/Permissions";

export default () => {
  const history = useHistory();

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastVariant, setToastVariant] = useState("success");

  const [showModal, setShowModal] = useState(false);
  const [channelOptions] = useState([
    // { value: "SMS", label: "SMS", icon: <AiFillMessage /> },
    { value: "WhatsApp", label: "WhatsApp", icon: <IoLogoWhatsapp /> },
    // { value: "RCS", label: "RCS", icon: <BiSolidMessageSquareDetail /> },
  ]);
  const [channel, setChannel] = useState(null);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [errors, setErrors] = useState({});
  const [validated, setValidated] = useState(false);

  const [cards, setCards] = useState([]);
  // const [editingCardId, setEditingCardId] = useState(null); // Track card being edited

  const SwalWithBootstrapButtons = withReactContent(
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-secondary me-3",
        cancelButton: "btn btn-gray",
      },
      buttonsStyling: false,
    })
  );

  useEffect(() => {
    fetchChatCards();
  }, []);

  const [getListofChats] = useGetFlowsMutation();

  const fetchChatCards = async () => {
    try {
      const response = await getListofChats();
      if (response?.data?.statusCode === 200) {
        setCards(response?.data?.data?.queryData);
      } else {
        setCards([]);
      }
    } catch (error) {
      alert(error.message);
    }
  };

  const handleAddAPI = () => {
    history.push(Routes.ChatBotApi.path)
  };

  const handleAddChatbot = () => {
    setShowModal(true);
  };

  // submits modal data, goes to flow screen
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Form validation
    let formErrors = {};
    if (!channel) {
      formErrors.channel = "Channel is required";
    }
    if (!name) {
      formErrors.name = "Name is required";
    }

    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      setValidated(true);
      return; // Prevent form submission if validation fails
    }

    // Adding a new card
    const newCard = {
      channel: channel?.label,
      name: name,
      description: description,
    };
    setShowModal(false);
    history.push(Routes.ChatFlowScreen.path);
    localStorage.setItem("chatDetails", JSON.stringify(newCard));
    setChannel(null);
    setName("");
    setDescription("");
    setErrors({});
  };

  // const handleDelete = async(id) => {
  //   const textMessage = "Are you sure you want to delete this ChatBot Flow?";
  //   const result = await SwalWithBootstrapButtons.fire({
  //     icon: "question",
  //     title: "Confirm deletion",
  //     text: textMessage,
  //     showCancelButton: true,
  //     confirmButtonText: "Yes",
  //     cancelButtonText: "Cancel",
  //   });
  //   if (result.isConfirmed) {

  //     setCards(cards.filter((card) => card.id !== id));
  //     SwalWithBootstrapButtons.fire(
  //       "Deleted",
  //       "Chatbot deleted successfully!",
  //       "success"
  //     );
  //     // const newUsers = tableData.filter(f => f.id !== usersToBeDeleted);
  //     // deleteAccountsApi({ system_id: ids })
  //     //   .then(async (response) => {
  //     //     console.log("response", response.data);
  //     //     if (response?.data?.statusCode === 200) {
  //     //       await SwalWithBootstrapButtons.fire(
  //     //         "Deleted",
  //     //         "Chatbot deleted successfully!",
  //     //         "success"
  //     //       );
  //     //       fetchChatCards();
  //     //     } else {
  //     //       const failureMsg = "Failed to Delete.";
  //     //       await SwalWithBootstrapButtons.fire("Failed", failureMsg, "error");
  //     //     }
  //     //   })
  //     //   .catch(async (err) => {
  //     //     const errMsg = err?.message || "Error deleting this ChatBot Flow.";
  //     //     await SwalWithBootstrapButtons.fire("Failed", errMsg, "error");
  //     //   });
  //   }
  // };

  const [changeStatus] = useChangeFlowStatusMutation();
  const handleStatus = async (id, status) => {
    const updatedStatus = status === "inactive" ? "active" : "inactive";

    const postData = {
      flowId: id,
      status: updatedStatus,
    };

    changeStatus(postData)
      .then((success) => {
        if (
          success?.data?.statusCode >= 200 &&
          success?.data?.statusCode <= 204
        ) {
          setToastVariant("success");
          setToastMessage(
            success?.data?.message || "Status updated successfully"
          );
          // to update UI for diff usecases
          fetchChatCards();
        } else {
          setToastVariant("danger");
          setToastMessage(success.message || "Something went wrong!");
        }
        setShowToast(true);
      })
      .catch((error) => {
        setToastVariant("danger");
        setToastMessage(error.message || "Failed to update status");
        setShowToast(true);
      });
  };

  const handleEdit = (id) => {
    const cardToEdit = cards.find((card) => card.id === id);
    history.push(Routes.ChatFlowScreen.path);
    localStorage.setItem("chatDetails", JSON.stringify(cardToEdit));
  };

  // Clear error when user starts typing or selects an option
  const handleInputChange = (e, field) => {
    if (e.target.value) {
      setErrors((prevErrors) => ({ ...prevErrors, [field]: "" }));
    }
    if (field === "name") {
      setName(e.target.value);
    } else if (field === "description") {
      setDescription(e.target.value);
    }
  };

  const handleSelectChange = (selectedOption) => {
    if (selectedOption) {
      setErrors((prevErrors) => ({ ...prevErrors, channel: "" }));
      setChannel(selectedOption);
    }
  };

  const getChannelIcon = (channelName) => {
    switch (channelName) {
      case "SMS":
        return <AiFillMessage style={{ color: "blue" }} />;
      case "WhatsApp":
        return <IoLogoWhatsapp style={{ color: "#25D366" }} />;
      case "RCS":
        return <BiSolidMessageSquareDetail style={{ color: "darkorange" }} />;
      default:
        return null;
    }
  };

  const canEdit = hasPermission("ChatBot", "edit");
  const canDelete = hasPermission("ChatBot", "delete");

  return (
    <>
      <ToastContainer position="top-end" className="p-3">
        <Toast
          bg={toastVariant}
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>

      <Card
        style={{ padding: "0.38rem", borderRadius: "14px", marginBottom: 0 }}
      >
        <div className="d-flex justify-content-between align-items-center">
          <p className="m-0 ms-2" style={{ fontSize: "1rem" }}>
            {!cards
              ? "No Chatbot Flows Yet"
              : `Conversation Flows — ${cards.length} Created`}
          </p>
          <div className="d-flex align-items-center gap-2">
            {/* Add Chatbot Button */}
            {canEdit && (
              <Button
                onClick={handleAddAPI}
                variant="secondary"
                size="sm"
                className="d-inline-flex align-items-center"
                style={{ borderRadius: "12px" }}
              >
                <PlusIcon className="icon icon-xxs me-2" />
                 API
              </Button>
            )}
            {/* Add Chatbot Button */}
            {canEdit && (
              <Button
                onClick={handleAddChatbot}
                variant="secondary"
                size="sm"
                className="d-inline-flex align-items-center"
                style={{ borderRadius: "12px" }}
              >
                <PlusIcon className="icon icon-xxs me-2" />
                Add Chatbot
              </Button>
            )}
          </div>
        </div>
      </Card>

      {/* Create Chatbot Button and Cards  */}
      <div style={{ minHeight: "74vh" }}>
        {/* <button
          className="d-flex align-items-center justify-content-center text-white rounded-lg shadow"
          style={{
            width: "150px",
            height: "150px",
            backgroundColor: "#09090B",
            fontSize: "14px",
          }}
          onClick={handleAddChatbot}
        >
          <PlusIcon className="me-2" style={{ width: "20px", height: "20px" }} />
          
        </button> */}

        {/* Chatbot Cards */}
        <div className="d-flex flex-wrap gap-2 m-3">
          {cards.map((card) => (
            <Card
              key={card.id}
              style={{
                width: "270px",
                height: "200px",
                padding: "10px",
                textAlign: "left",
                borderRadius: "16px",
                margin: 0,
              }}
            >
              {/* Card Content */}
              <Card.Body className="d-flex flex-column p-0">
                <div className="d-flex align-items-center border-bottom pb-1">
                  <span className="me-2 fs-4 d-flex align-items-center">
                    {getChannelIcon(card.channel)}
                  </span>
                  <Card.Title className="mb-0 ">
                    {card.name.toUpperCase()}
                  </Card.Title>
                </div>
                <div className="mt-2">
                  <Card.Text
                    style={{
                      fontSize: "12px",
                      marginTop: "2px",
                      marginBottom: "0px",
                    }}
                    className="truncate-twoline"
                  >
                    {card.description}
                  </Card.Text>
                </div>
                <div className="mt-2 d-flex align-items-center">
                  <Card.Text
                    style={{
                      fontSize: "14px",
                      fontWeight: "500",
                      marginBottom: "0px",
                    }}
                    className=""
                  >
                    Status:{" "}
                    <span
                      className={
                        card.status === "inactive"
                          ? "text-danger text-capitalize"
                          : "text-success text-capitalize"
                      }
                    >
                      {card.status}
                    </span>
                  </Card.Text>
                </div>

                {/* Edit, Delete, Play, and Pause Buttons */}
                {(canEdit || canDelete) && (
                  <div
                    style={{
                      position: "absolute",
                      bottom: "10px",
                      right: "12px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {/* Edit Button */}
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip className="m-0">Edit</Tooltip>}
                    >
                      <Card.Link onClick={() => handleEdit(card.id)}>
                        <TbEdit className="icon icon-xs text-info" />
                      </Card.Link>
                    </OverlayTrigger>

                    {/* Delete Button */}
                    {/* {canDelete && (
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip className="m-0">Delete</Tooltip>}
                      >
                        <Card.Link onClick={() => handleDelete(card.id)}>
                          <TbTrash className="icon icon-xs text-danger" />
                        </Card.Link>
                      </OverlayTrigger>
                    )} */}

                    {/* Play or Pause Button */}
                    {card.status === "inactive" ? (
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip className="m-0">Activate</Tooltip>}
                      >
                        <Card.Link
                          onClick={() => handleStatus(card.id, card.status)}
                        >
                          <IoPlay className="icon icon-xs text-success" />
                        </Card.Link>
                      </OverlayTrigger>
                    ) : (
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip className="m-0">Pause</Tooltip>}
                      >
                        <Card.Link
                          onClick={() => handleStatus(card.id, card.status)}
                        >
                          <IoPauseCircleOutline className="icon icon-xs text-warning" />
                        </Card.Link>
                      </OverlayTrigger>
                    )}
                  </div>
                )}
              </Card.Body>
            </Card>
          ))}
        </div>
      </div>

      {/* Modal for Add Chatbot */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Chatbot</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit} noValidate validated={validated}>
            {/* Channel Select with Validation Error */}
            <Form.Group className="mb-3">
              <Form.Label>
                Select Channel <span className="text-danger"> * </span>
              </Form.Label>
              <Select
                options={channelOptions}
                value={channel}
                onChange={handleSelectChange}
                placeholder="Choose channel"
                styles={{
                  control: (provided, state) => ({
                    ...provided,
                    borderColor:
                      validated && !channel
                        ? "#dc3545"
                        : validated && channel
                        ? "#65BB82"
                        : provided.borderColor,
                    borderRadius: "0.75rem",
                  }),
                }}
              />
              {errors.channel && (
                <div className="text-danger">{errors.channel}</div>
              )}
            </Form.Group>

            {/* Name Input with Validation Error */}
            <Form.Group className="mb-3">
              <Form.Label>
                Name <span className="text-danger"> * </span>
              </Form.Label>
              <InputGroup>
                <Form.Control
                  required
                  type="text"
                  placeholder="Enter name"
                  value={name}
                  maxLength={100}
                  onChange={(e) => handleInputChange(e, "name")}
                />
              </InputGroup>
              {errors.name && <div className="text-danger">{errors.name}</div>}
            </Form.Group>

            {/* Description Textarea with Validation Error */}
            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                maxLength={300}
                placeholder="Enter description"
                value={description}
                onChange={(e) => handleInputChange(e, "description")}
              />
            </Form.Group>

            <Button type="submit" className="w-100" variant="secondary">
              Submit
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};
